import { ReportSummaryConfigBase } from "../../summary/types";

export const Summary: ReportSummaryConfigBase[] = [
  {
    label: "Number of Suppliers",
    fields: ["row_count"],
    type: ["COUNT"],
  },
  {
    label: "Current Period Spend",
    fields: ["total_spend"],
    type: ["MONEY"],
  },
  {
    label: "Previous Period Spend",
    fields: ["prev_spend"],
    type: ["MONEY"],
  },
];
